<template>
  <div class="no-search-results-found container">
    <div class="columns is-vcentered is-centered">
      <div class="column">
        <div class="wrapper">
          <div><img class="search-icon" src="./search-180px.svg" alt="search icon" /></div>
          <h2 class="heading-text">{{ heading }}</h2>
          <p class="body-text">{{ body }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'NoSearchResultsFound',
  props: {
    heading: VueTypes.string.def('No Search Results Found'),
    body: VueTypes.string.def("Try a different keyword to find what you're looking for."),
  },
};
</script>

<style lang="scss" scoped>
.no-search-results-found {
  .wrapper {
    margin-top: 80px;
    text-align: center;

    > div {
      display: flex;
      justify-content: center;
      img {
        width: 180px;

        @media (max-width: $mobile-max-width) {
          width: 100px;
        }
      }
    }
  }
  .search-icon {
    padding: 18px;
  }
  .heading-text,
  .body-text {
    color: #4a4a4a;
    font-family: Montserrat;
    font-size: 25px;
    line-height: 40px;

    @media (max-width: $mobile-max-width) {
      font-size: 18px;
      line-height: 30px;
    }
  }
  .heading-text {
    font-weight: bold;
  }
}

.themed-app {
  .no-search-results-found {
    .body-text {
      color: $theme-color-gray-darker;
    }
  }
}
</style>
